<template>
  <kd-layout-fixed-bottom-button class="select-my-gift-address-page">
    <div class="address-list">
      <div class="address-option" v-for="(address, index) in addressList" :key="index">
        <kd-radio round v-model="address.default" @change="updateCheck(index)">
          <div class="info-box">
            <div class="user">
              <div class="name">{{ address.name }}</div>
              <div class="phone">{{ address.phone }}</div>
            </div>

            <div class="address">{{ service.formatGifFullAddress(address) }}</div>
          </div>
        </kd-radio>
      </div>
    </div>
    <template #footer>
      <kd-button class="new-address" @click="addNewAddress">新地址</kd-button>
      <kd-button class="confirm" @click="navToMyAddressList">确认</kd-button>
    </template>
  </kd-layout-fixed-bottom-button>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import { KdLayoutFixedBottomButton, KdButton, KdRadio } from 'kuaidong-ui'
import { IGiftOrderDetail, ITeacherAddressInfo } from 'kuaidong-model'
import { AGiftOrder } from 'kuaidong-api/src/AGiftOrder'
import { GiftOrderService } from 'kuaidong-service/src/GiftOrderService'
@Component({
  components: { KdLayoutFixedBottomButton, KdButton, KdRadio },
})
export default class SelectMyGiftAddressPage extends BasePage {
  @Prop({ type: Object, required: true })
  addressInfo!: IGiftOrderDetail

  addressList: ITeacherAddressInfo[] = []

  get giftOrderId() {
    return this.addressInfo.gift_order_id
  }

  get service() {
    return GiftOrderService
  }
  async created() {
    await this.fetchAddressList()
  }

  async fetchAddressList() {
    this.addressList = await AGiftOrder.teacherAddressList()
  }

  updateCheck(index: number) {
    this.addressList.forEach((item, curIndex) => {
      if (index !== curIndex) {
        item.default = false
      }
    })
  }

  async updateAddressInfo() {
    const selectAddress = this.addressList.find((item) => {
      return item.default === true
    }) as ITeacherAddressInfo
    if (!selectAddress) {
      this.toast('请选择一个地址~')
      return
    }

    try {
      await AGiftOrder.updateGiftOrderAddress(this.giftOrderId, selectAddress.address_id)
      this.toast('已修改地址~')

      this.$router.go(-1)
    } catch (e) {
      this.toast(e.text || '修改收货地址发生错误~')
    }
  }

  addNewAddress() {
    this.$router.push({
      name: 'add_gift_address',
    })
  }

  async navToMyAddressList() {
    try {
      await this.updateAddressInfo()
    } catch (e) {
      return
    }
  }
}
</script>
<style lang="less">
.kd-layout-fixed-bottom-button.select-my-gift-address-page {
  > .kd-layout-fixed-bottom__main {
    > .address-list {
      display: flex;
      flex-direction: column;
      background: #fff;
      justify-content: center;
      > .address-option {
        display: flex;
        align-items: center;
        padding: 16px;

        > .kd-radio {
          font-size: 18px;
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          flex-shrink: 0;
          padding-bottom: 15px;
          border-bottom: 1px solid #f5f5f5;
          > .info-box {
            display: flex;
            flex-direction: column;
            margin-left: 19px;
            width: 300px;
            > .user {
              display: flex;
              align-items: center;
              > .name {
                font-weight: 500;
                font-size: 16px;
                line-height: 22px;
                color: #000000;
                margin-right: 8px;
              }
              > .phone {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #8f8f8f;
              }
            }

            > .address {
              margin-top: 12px;
              font-weight: 400;
              font-size: 14px;
              line-height: 131%;
              color: #4d4d4d;
              text-align: left;
            }
          }
        }
      }
    }
  }
  > .kd-layout-fixed-bottom__footer {
    display: flex;
    > .new-address {
      background: #ffffff;
      border: 1px solid #e1e4ed;
      border-radius: 8px;
      margin-right: 24px;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 1px;
      color: #4d4d4d;
      width: 102px;
      box-sizing: border-box;
    }
    > .confirm {
      flex: 1;
    }
  }
}
</style>
